"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogDadosSalvar = void 0;
var bson_1 = require("bson");
var LogDadosSalvar = /** @class */ (function () {
    function LogDadosSalvar() {
        this._id = new bson_1.ObjectId();
        this.MATERIAL = '';
        this.DATA_REM = '';
        this.ESTACAO = '';
        this.COLECAO = '';
        this.GRADE = {};
        this.VERID = '';
        this.CONJUNTOS = {};
        this.MAT_DOC = {};
        this.chaveCompAlterado = {
            material: '',
            data: '',
            estacao: '',
            colecao: '',
        };
    }
    return LogDadosSalvar;
}());
exports.LogDadosSalvar = LogDadosSalvar;
//# sourceMappingURL=LogDadosSalvar.js.map